'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoomingReasonText = function RoomingReasonText(_ref) {
    var code = _ref.code;

    if (code) {
        var msg = void 0;
        switch (code) {
            case 'SHARED_BOOKING':
            case 'SHARED_DEPARTURE_SERVICE':
            case 'SHARED_LINKED_BOOKING':
            case 'SHARED_GENDER':
            case 'CLOSEST_AGE':
                {
                    msg = _react2.default.createElement('div', null);
                    break;
                }
            case 'MY_OWN_ROOM':
                {
                    msg = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'roomingReasons.texts.myOwnRoom',
                                defaultMessage: 'We roomed you in your own room because you booked My Own Room.' })
                        )
                    );
                    break;
                }
            case 'REQUEST':
                {
                    msg = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'roomingReasons.texts.request',
                                defaultMessage: 'We roomed you together because of a request.' })
                        )
                    );
                    break;
                }
            default:
                {
                    msg = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'roomingReasons.texts.default',
                                defaultMessage: 'We roomed you together because you are on the shared booking.' })
                        )
                    );
                }
        }
        return _react2.default.createElement(
            'div',
            { className: 'alert', role: 'alert' },
            msg
        );
    } else {
        return _react2.default.createElement('div', null);
    }
};
exports.default = (0, _pacomo.pacomoTransformer)(RoomingReasonText);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/RoomingReasonText.js
// module id = 635
// module chunks = 0